import { axiosInstance } from "@src/api/axiosConfig";
import { getExpertListResponse, getExpertListRequest } from "./expertSearch.type";

const nestURL = process.env.REACT_APP_NEST_API_URL;

export const getExpertList = async (params?: getExpertListRequest): Promise<getExpertListResponse> => {
    const { data } = await axiosInstance.get(`${nestURL}/match/experts/overview`, { params });
    return data;
};
